import axios from "axios";

const peerviewAPI = axios.create({ baseURL: process.env.NEXT_PUBLIC_PEERVIEW_URI });

export async function getRating(type: string, identifier: string) {
    const key = process.env.NEXT_PUBLIC_PEERVIEW_KEY;
    const { data } = await peerviewAPI.get(`/api?key=${key}&type=${type}&identifier=${identifier}`);

    return data;
}